import { AxiosInstance } from 'axios';
import AxiosBase from './helperBase';
import { store } from 'store/store';
import { MapPointQuery } from "./map/MapPointQuery";
import { CampaignResponse } from 'view/CampaignDetails/CampaignDetailsModel';

class MapService {
    base: AxiosInstance;

    constructor() {
        this.base = AxiosBase.base;
    }

    // Clients
    getIpCategories(locale?: string, signal?: AbortSignal): Promise<any[]> {
        const state = store.getState();
        const language = state.language.language;

        return new Promise(async (resolve, reject) => {
            this.base
                .get(`ip-categories/?locale=${locale || language}`, { signal, timeout: 45000 })
                .then(({ data }) => {
                    return resolve(data);
                })
                .catch((err) => reject(err));
        });
    }

    getIpPoints(categoryId: number, locale: string, signal: AbortSignal) {
        return new MapPointQuery(this.base, "ip-points/").getPoints(categoryId, locale, signal);
    }

    getDefibrilators(signal?: AbortSignal, locale?: string): Promise<any[]> {
        const state = store.getState();
        const language = state.language.language;

        return new Promise(async (resolve, reject) => {
            this.base
                .get(`get-scheduled?locale=${locale || language}`, { signal, timeout: 45000 })
                .then(({ data }) => {
                    return resolve(data);
                })
                .catch((err) => reject(err));
        });
    }

    getCampaigns(): Promise<{ data: any[] }> {
        const state = store.getState();
        const language = state.language.language;

        return new Promise(async (resolve, reject) => {
            this.base
                .get(`/campaigns?populate=*&pagination[pageSize]=100&locale=${language}`)
                .then(({ data }) => {
                    return resolve(data);
                })
                .catch((err) => reject(err));
        });
    }

    getCampaign(campaignId: string): Promise<CampaignResponse> {
        const state = store.getState();
        const language = state.language.language;

        return new Promise(async (resolve, reject) => {
            this.base
                .get(`/campaigns/${campaignId}/?populate=*&locale=${language}`)
                .then(({ data }) => {
                    return resolve(data);
                })
                .catch((err) => reject(err));
        });
    }
}

const mapService = new MapService();
export default mapService;
